var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRefund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0444 11.3889C10.7833 11.0611 10.3778 10.7222 10.3778 10.1944C10.3778 9.58889 10.9389 9.16667 11.8778 9.16667C12.8667 9.16667 13.2333 9.63889 13.2667 10.3333H14.4944C14.4556 9.37778 13.8722 8.5 12.7111 8.21667V7H11.0444V8.2C9.96667 8.43333 9.1 9.13333 9.1 10.2056C9.1 11.4889 10.1611 12.1278 11.7111 12.5C13.1 12.8333 13.3778 13.3222 13.3778 13.8389C13.3778 14.2222 13.1056 14.8333 11.8778 14.8333C10.7333 14.8333 10.2833 14.3222 10.2222 13.6667H9C9.06667 14.8833 9.97778 15.5667 11.0444 15.7944V17H12.7111V15.8056C13.7944 15.6 14.6556 14.9722 14.6556 13.8333C14.6556 12.2556 13.3056 11.7167 12.0444 11.3889Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.895 19.8982C14.1188 20.8627 12.0696 21.2011 10.0775 20.8591C8.08547 20.517 6.26655 19.5144 4.91374 18.0127C3.56094 16.5109 2.753 14.5976 2.62008 12.5807C2.48716 10.5639 3.03699 8.56107 4.18101 6.89479C5.32503 5.22852 6.99663 3.99584 8.92656 3.39531C10.8565 2.79478 12.9324 2.86136 14.8198 3.58433C16.7073 4.30731 18.2965 5.64457 19.3314 7.38074C20.3663 9.1169 20.7866 11.1509 20.5247 13.155L19.4246 13.0113C19.6542 11.2542 19.2857 9.47094 18.3784 7.94881C17.471 6.42667 16.0778 5.25426 14.423 4.62041C12.7682 3.98656 10.9482 3.92819 9.2562 4.45469C7.56419 4.98119 6.09865 6.06191 5.09566 7.52277C4.09268 8.98363 3.61062 10.7396 3.72716 12.5078C3.84369 14.276 4.55203 15.9535 5.73807 17.2701C6.92411 18.5867 8.5188 19.4657 10.2653 19.7656C12.0117 20.0655 13.8083 19.7687 15.3656 18.9232L15.895 19.8982Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3115 21.0521L18.2725 17.9655L14.619 17.8105L16.3115 21.0521Z",
    fill: "#B4B4B4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRefund);
export default __webpack_public_path__ + "static/media/No-refund.4c13294503a32c99e1fc582ac8b4de32.svg";
export { ForwardRef as ReactComponent };